import { render, staticRenderFns } from "./app.vue?vue&type=template&id=4148efee&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TritonPresentation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4148efee')) {
      api.createRecord('4148efee', component.options)
    } else {
      api.reload('4148efee', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=4148efee&", function () {
      api.rerender('4148efee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Scripts/app/app.vue"
export default component.exports